import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import {inject, observer} from "mobx-react";
import styles from "./styles";
import {Info as InfoIcon, Refresh} from '@material-ui/icons';
import {
    Box,
    Button, Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText, Grid,
    IconButton,
    Tooltip, Typography,
    withStyles
} from "@material-ui/core";
import CreateClaimForm from "../../components/claims/CreateClaimForm";
import {ModalDialog} from "../../components/Modal";
import {Alert} from "@material-ui/lab";
import AxlSearchBox from "../../components/AxlSearchBox";
import moment from "moment";
import AxlDatePicker from "../../components/AxlDatePicker";
import List from "../../components/List";
import {LoadingOverlay} from "../../components/LoadingOverlay";
import {AxlButton, AxlMultiSelect} from "axl-reactjs-ui";
import ClaimDownloadReport from "../../components/claims/ClaimDownloadReport";
import ListHeaderToolTipLabel from "../../components/ListHeaderToolTipLabel";
import ClaimListStatusLabel from "../../components/claims/ClaimListStatusLabel";
import ClaimDocumentUpload from "../../components/claims/ClaimDocumentUpload";
import GenerateDialog from "../../components/ReportComponents/GenerateDialog";
import {getReport, requestReport} from "../../stores/api";
import attachmentIcon from "../../assets/images/attachment.svg";
import UploadedDocuments from "../../components/claims/UploadedDocuments";
import ClaimsListFilter from "../../components/claims/ClaimsListFilter/ClaimsListFilter";


const MAX_FILE_SIZE = 5*1024*1024; // 5MB

@inject("insuranceStore", "claimsListStore", "reportStore", "reportFormStore","userStore", "deliveryStore")
@observer
class ClaimsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showCreateClaimModal: false,
            showInstructionsModal: false,
            showCreateClaimSuccessModal: false,
            showCreateClaimQueuedSuccessModal: false,
            showDocumentUploadModal: false,
            showUploadedDocumentsModal: false,
            showDownloadReportModal: false,
            showGeneratingReportModal: false,
            selectedClaim: null,
            createdClaimNumber: null,
            receivedDate: null,
            claimUploadDocumentType: '',
            query: '',
            files: [],
            fileErrors: [],
            stagedFiles: [],
            clientProfiles : [],
            brandSelectOpen: false,
            selectedBrands: [],
        }
    }

    componentDidMount() {
        const {insuranceStore, claimsListStore, userStore, history} = this.props;

        if (!userStore.isClaimsEnabled) {
            history?.replace("/");
            return;
        }

        insuranceStore.reset();
        insuranceStore.getClaimDescriptions();
        insuranceStore.getClaimDocumentTypes();
        claimsListStore.reset();
        claimsListStore.search();
        userStore.getClientProfiles();
        insuranceStore.getClaimsStatuses()
    }


    openModal(name){
        const formStateName = `show${name}Modal`;
        this.setState({[formStateName]: true});
    };

    closeModal(name){
        const formStateName = `show${name}Modal`;
        this.setState({[formStateName]: false});
    };

    onSuccessFulClaimCreation = async (claim) => {
        const { claimsListStore } = this.props;
        this.closeModal(`CreateClaim`);
        await claimsListStore.search();
        if(claim?.claimStatus == "QUEUED"){
            this.openModal(`CreateClaimQueuedSuccess`);
        }else {
            this.setState({createdClaimNumber: claim.claimNumber});
            this.openModal(`CreateClaimSuccess`);
        }


    }
    changeSearch = (e) => {
        const value = e.target.value.replace(/\D/,'');
        this.setState({
            query: value,
        });
    };

    handleChangeDate = (value) => {
        const { claimsListStore } = this.props;
        const { filters } = claimsListStore;

        let updatedFilters = {
            ...filters,
            fromDate: moment(value).format('YYYY-MM-DD'),
            toDate: moment(value).format('YYYY-MM-DD')
        };
        if(!!value){
            updatedFilters = {
                ...updatedFilters,
                fromDate: moment(value).format('YYYY-MM-DD'),
                toDate: moment(value).format('YYYY-MM-DD')
            };
        }else{
            updatedFilters = {
                ...updatedFilters,
                fromDate: null,
                toDate: null
            };
        }
        claimsListStore.setFilters(updatedFilters);
        this.setState({ receivedDate: value });
        claimsListStore.search();

    }
    handleBrandSelectOpen = (open) => {
        this.setState({brandSelectOpen: open})
    }
    handleBrandSelectClose = () => {
        this.updateBrandFilter();
        this.setState({brandSelectOpen: false});

    }

    updateBrandFilter = () => {
        const { selectedBrands } = this.state;
        const { claimsListStore } = this.props;
        const { filters } = claimsListStore;
        const ids = selectedBrands.map(({ value }) => value);
        const updatedFilters = {
            ...filters,
            clientProfileIds: ids
        };
        claimsListStore.setFilters(updatedFilters);
        claimsListStore.search();
    }


    handleBrandsSelectChange = (event,selected,reason) => {
        const { brandSelectOpen, selectedBrands } = this.state;

        if(brandSelectOpen){
            this.setState({selectedBrands: selected});
        }
        else if(reason === 'remove-option' || reason === 'clear'){
            this.setState({selectedBrands: selected}, () => {
                this.updateBrandFilter()
            });
        }
    };

    onSearchEnter = (e) => {
        const { claimsListStore } = this.props;
        const { filters } = claimsListStore;
        const updatedFilters = {
            ...filters,
            q: this.state.query,
            page: 1
        };

        claimsListStore.setFilters(updatedFilters);
        claimsListStore.search();
    }

    clearSearch = (e) => {
        const { claimsListStore } = this.props;
        const { filters } = claimsListStore;
        const updatedFilters = {
            ...filters,
            q: ''
        };

        claimsListStore.setFilters(updatedFilters);
        claimsListStore.search();
        this.setState({ query: '' });
    }

    handleOkButton = async () => {
        const { insuranceStore } = this.props;
        const { createClaimStep, isOneStepClaim } = insuranceStore;


        if(isOneStepClaim){
            const isValid = await insuranceStore.validateClaimForm();
            if(isValid) {
                await insuranceStore.createClaim(this.onSuccessFulClaimCreation);
            }
            return;
        }

        switch (createClaimStep) {
            case 1:
                insuranceStore.setCreateClaimStep(createClaimStep + 1);
                break;
            case 2:
                const isValid = await insuranceStore.validateClaimForm();
                if(isValid) {
                    await insuranceStore.createClaim(this.onSuccessFulClaimCreation);
                }
                break;

        }

    }

    handlePreviousButton = () => {
        const { insuranceStore } = this.props;
        const {  createClaimStep } = insuranceStore;

        switch (createClaimStep) {
            case 2:
            case 3:
                insuranceStore.setCreateClaimStep(createClaimStep - 1);
                break;
            default:
                insuranceStore.setCreateClaimStep(1);
                break;
        }

    }

    refreshClaim = (shipmentId) => {
        const {  claimsListStore } = this.props;
        claimsListStore.refreshClaim(shipmentId);
    }

    handleDocumentUploadClick = (e,row) => {
        this.setState({selectedClaim: row, stagedFiles:[], files: [], fileErrors: [], claimUploadDocumentType: ''});
        this.openModal(`DocumentUpload`);
    }

    handleShowUploadedDocumentsClick = (e,row) => {
        this.setState({selectedClaim: row});
        this.openModal(`UploadedDocuments`);
    }

    handleShowUploadedDocumentsClose = () => {
        this.setState({selectedClaim: null});
        this.closeModal('UploadedDocuments');
    }
    getUploadedDocument = (file, download) => {
        const { selectedClaim } = this.state;
        const { claimsListStore } = this.props;
        claimsListStore.getUploadedDocument(selectedClaim,file, download);

    }


    renderClaimStatus = (row) => {
        let status = row.claim_status;
        if(row.claim_status === 'Documents Pending') {
            status = <a href="#" onClick={(e) => this.handleDocumentUploadClick(e, row)}>
                {row.claim_status}
            </a>
        }
        return <>
            { status }
            {  row.claim_documents && row.claim_documents.length > 0  &&
                <Tooltip title="Show Uploaded Documents">
                    <a href="#" onClick={(e) => this.handleShowUploadedDocumentsClick(e, row)}>
                        <img alt="attachment" height="11px" style={{paddingLeft:'10px'}} src={attachmentIcon}/>
                    </a>
                </Tooltip>
            }
        </>
    }

    handleDownloadReportButton = (e) => {
        this.props.reportStore.reset();
        this.openModal(`DownloadReport`);
    }

    renderClaimValueLabel = (header) => {
        const { classes } = this.props;
        const text = "Claim Value = Product Retail Value + Shipping Amount";
        return (
            <ListHeaderToolTipLabel label={header.label} text={text} placement={"bottom"} classes={classes}/>
        )
    }

    renderClaimStatusLabel = (header) => {
        const { insuranceStore } = this.props;
        const text = <ClaimListStatusLabel claimStatuses={insuranceStore.claimStatuses} />
        return (
            <ListHeaderToolTipLabel label={header.label} text={text} placement={"bottom"} />
        )
    }

    onDrop = (droppedFiles) => {
        if(droppedFiles.length > 0) {
            droppedFiles = droppedFiles.map((file) => {
                const sanitizedFileName = this.sanitizeFileName(file.name);
                return new File([file], sanitizedFileName, {type: file.type});
            });

            this.setState({files: droppedFiles});
        }
    }

    onDropRejected = (rejectedFiles, event) => {
        if(rejectedFiles && rejectedFiles.length > 0) {
            if(rejectedFiles[0].errors && rejectedFiles[0].errors.length > 0) {
                const code = rejectedFiles[0].errors[0].code
                if(code === 'file-too-large') {
                    this.setState({fileErrors: ['Maximum file upload size is 5MB.'], files: []});
                }else if(code === 'file-invalid-type') {
                    this.setState({fileErrors: ['Only .pdf, .jpg formats are supported'], files: []});
                }else {
                    this.setState({fileErrors: [rejectedFiles[0].errors[0].message], files: []});
                }
            }
        }
    }

    sanitizeFileName = (name) => {
        //sanitize for s3 bucket
        return name.replace(/[^a-zA-Z0-9-_.]/g, '_');
    }

    onDropAccepted = (droppedFiles) => {
        const { stagedFiles, selectedClaim } = this.state;
        if(droppedFiles.length > 0) {
            const droppedFileName = this.sanitizeFileName(droppedFiles[0].name);
            const stagedFileNames = stagedFiles.map((f) => f.file.name);
            const existingFileNames = selectedClaim.claim_documents.map((f) => f.name);
            if(stagedFileNames.includes(droppedFileName)){
                this.setState({fileErrors: [`A File with the name ${droppedFileName} has already been queued for upload.`]});
                return;
            }
            if(existingFileNames.includes(droppedFileName)){
                this.setState({fileErrors: [`A File with the name ${droppedFileName} has already been uploaded.`]});
                return;
            }
        }

        this.setState({fileErrors: []});
    }

    handleDocumentUploadSubmit = () => {
        const { stagedFiles, selectedClaim } = this.state;
        const {  claimsListStore } = this.props;
        const { shipment_id, claim_number } = selectedClaim;

        claimsListStore.uploadClaimDocuments(stagedFiles, shipment_id, claim_number,
            (success) =>  this.closeModal('DocumentUpload'));
    }
    handleDocumentUploadCancel = () => {
        this.setState({stagedFiles:[], files: [], fileErrors: [], selectedClaim: null, claimUploadDocumentType: ''});
        this.closeModal('DocumentUpload');
    }
    setClaimUploadDocumentType = (type) => {
        this.setState({claimUploadDocumentType:type});
    }

    handleDownloadReportSubmit = (fromDate, toDate) => {
        this.closeModal('DownloadReport');
        this.openModal('GeneratingReport');
        this.setState({fromDate: fromDate, toDate: toDate},this.generateReport);

    }

    downloadUrl = (id, e) => {
        if (e) e.preventDefault();
        window.open(`${import.meta.env.REACT_APP_API_ROOT}/reports/uploaded/${id}/download`, '_blank', 'noopener');
    }

    generateReport = () => {
        const { fromDate, toDate, selectedBrands } = this.state;
        const { reportStore } = this.props;
        reportStore.setError("");
        reportStore.setReportRequest({status:"PENDING"});
        const request = {
                type: 'insurance-claims',
                report_params: {
                    dateRange: {
                        dateType: 'range',
                        fromDate: fromDate,
                        toDate: toDate
                    },
                    client_profile_ids: selectedBrands && selectedBrands.length > 0 ? selectedBrands.map((b) => b.value) : null,
                    regions:"all"
                }
            };
        requestReport(request).then(res => {
            if (res.ok) {
                const {id, status, url, count} = res.data;
                reportStore.setReportRequest({...request, id, status, url, count});
                this.fetchReport(id);
            } else {
                reportStore.setReportRequest({...request, status: "ERROR", url: null, count: null});
                reportStore.setError(res?.data?.errors?.length > 0 ? res.data.errors[0] : "Error while requesting report");
                reportStore.setPolling(false);
            }

        });
    }

    fetchReport = (id) => {
        const { reportStore } = this.props;
        const { reportRequest } = reportStore;
        reportStore.setPolling(true);
        getReport(id).then(res => {
            if (res.ok) {
                const {status, url, count} = res.data;
                reportStore.setReportRequest({...reportRequest, id, status, url, count});
                if (!["ERROR", "UPLOAD_ERROR", "COMPLETED", "NO_ITEMS"].includes(status)) {
                    setTimeout(() => {
                        this.fetchReport(id);
                    }, 5000);
                }

                if (["ERROR", "UPLOAD_ERROR", "COMPLETED", "NO_ITEMS"].includes(status)) {
                    reportStore.setPolling(false);
                }
            } else {
                reportStore.setError(res.data ? res.data.message : "Error while requesting report");
                reportStore.setPolling(false);
            }
        })
    }

    handleStageFile = () => {
        const { files, claimUploadDocumentType, stagedFiles } = this.state;
        stagedFiles.push(
            {
                file:new File([files[0]], files[0].name, {type: files[0].type}),
                claimUploadDocumentType: claimUploadDocumentType
            }
        );
        this.setState({stagedFiles:stagedFiles, files: [], fileErrors: [], claimUploadDocumentType: ''});
    }

    removeStagedFile = (index) => {
        const { stagedFiles } = this.state;
        const updatedStagedFiles = stagedFiles.filter((item, i) => i !== index);
        this.setState({stagedFiles:updatedStagedFiles, files: [], fileErrors: [], claimUploadDocumentType: ''});
    }

    render() {
        const { files, fileErrors, createdClaimNumber,claimUploadDocumentType, selectedClaim, selectedBrands } = this.state;
        const { insuranceStore, claimsListStore, classes, reportStore, userStore, deliveryStore } = this.props;
        const { loading, canSubmit, submitting, setError, error, createClaimStep, claimDocumentTypeOptions, isOneStepClaim  } = insuranceStore;
        const { result, searching, uploadErrors, uploading, fetching } = claimsListStore;
        const { reportRequest, existingReports,  error:reportError, polling } = reportStore;
        const { isBrandsOwner, clientProfileOptions, blurCustomerInfo } = userStore;
        const totalClaims = result?.count || 0;
        const { receivedDate } = this.state;
        const renderer = {
            received_date: (row) => row.received_date ? moment(row.received_date).format('MM/DD/YYYY  hh:mm a') : '',
            submitted_date: (row) => row.submitted_date ? moment(row.submitted_date).format('MM/DD/YYYY  hh:mm a') : '',
            paid_date: (row) => row.paid_date ? moment(row.paid_date).format('MM/DD/YYYY') : '',
            claim_status: (row) => row ? this.renderClaimStatus(row) : '',
        };
        const hidden = !isBrandsOwner ? ['brand_name'] : [];
        const selectedClaimUploadDocumentType = claimDocumentTypeOptions.find( (t) => t.value === claimUploadDocumentType);
        const isClaimReportEnabled = userStore?.permissions?.enable_claims_report === "true";

        let modalOkLabel = '';
        if(isOneStepClaim){
            modalOkLabel = 'SUBMIT';
        }else {
            switch (createClaimStep) {
                case 1:
                    modalOkLabel = 'NEXT';
                    break;
                case 2:
                default:
                    modalOkLabel = 'SUBMIT';
                    break;
            }
        }


        let additionalAction = null;
        if (createClaimStep > 1 && !isOneStepClaim) {
            additionalAction = {
                variant: 'outlined',
                onClick: this.handlePreviousButton,
                label: 'PREVIOUS',
            }
        }
        const rowActions = [
            {
                name: 'Refresh',
                render: (row) => {
                    return <Tooltip title="Get Updated Status">
                        <Refresh fontSize='small' htmlColor='#297ec8' className={classes.action}/>
                    </Tooltip>
                },
                onClick: (e,row) => {
                    this.refreshClaim(row.shipment_id);
                }
            }
        ]

        const headerRenderer = {
            claim_value: (header) => this.renderClaimValueLabel(header),
            claim_status: (header) => this.renderClaimStatusLabel(header)
        }



        return (
            <Container className={classes.container} maxWidth={false}>
                { (searching || loading) && <LoadingOverlay color="#887fff" />}
                <Grid container className={classes.header} direction="row" justifyContent="flex-end">
                    <Grid item xs={10}>
                        <Grid container direction="column">
                            <Grid container direction="row">
                                <Box mt={-0.625}>
                                    <IconButton size='small' disabled >
                                        <InfoIcon fontSize='small' htmlColor='#297ec8'/>
                                    </IconButton>
                                </Box>
                                <span className={classes.instructions}>Claims can be filed and submitted by clicking on the <span style={{fontWeight:"bold"}}>"+ New Claim"</span>&nbsp;  button. Existing claims can be viewed below.</span>
                            </Grid>
                            <Grid item className={classes.secondaryInstructions}>
                            For step by step instructions, click&nbsp;<Link to="/claims/instructions" target="_blank" rel="noopener">here</Link>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={2} className={classes.alignRight}>
                        <AxlButton
                            compact
                            bg={`periwinkle`}
                            style={{minWidth: 170, marginRight: '0px', paddingRight: '0px'}}
                            onClick={() => {
                                insuranceStore.reset();
                                this.openModal(`CreateClaim`)
                            }}
                        >{`+ New Claim`}</AxlButton>
                    </Grid>
                </Grid>

                <Grid container>
                    <ClaimsListFilter
                        isBrandsEnabled={isBrandsOwner}
                        handleChangeDate={this.handleChangeDate}
                        receivedDate={receivedDate}
                        clientProfileOptions={clientProfileOptions.map(profile => {
                            return {
                                label: profile.label,
                                value: profile.value
                            }
                        })}
                        selectedClientProfileOptions={selectedBrands}
                        handleBrandsSelectChange={this.handleBrandsSelectChange}
                        // classes={classes}
                        handleOnOpen={this.handleBrandSelectOpen}
                        handleOnClose={this.handleBrandSelectClose}
                        changeSearch={this.changeSearch}
                        onSearchEnter={this.onSearchEnter}
                        shipmentQuery={this.state.query}
                        clearSearch={this.clearSearch}

                    />
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={11}>
                            <Typography className={classes.title}>CLAIMS LIST</Typography>
                        </Grid>
                        <Grid item container xs={1} className={classes.alignRight}>
                            <Grid item>
                                TOTAL: {totalClaims}
                            </Grid>
                            { isClaimReportEnabled &&
                                <Grid item onClick={e => {
                                    this.handleDownloadReportButton(e)
                                }} className={classes.downloadReport}>
                                    <i style={{fontSize: 18, color: '#828282', cursor: 'pointer', margin: '0 3px'}}
                                       className={'fa fa-download'}/>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                    <List store={claimsListStore} renderer={renderer} emptyResponse={"There are no claims"} classes={classes} rowActions={rowActions} headerRenderer={headerRenderer} hidden={hidden} blurCustomerInfo={blurCustomerInfo} />
                </Grid>
                <ModalDialog
                    open={this.state.showCreateClaimModal}
                    style={styles.createClaimModal}
                    hideClose={true}
                    disabledOk={loading || !canSubmit || submitting}
                    minWidth="1250px"
                    onClose={() => this.closeModal(`CreateClaim`)}
                    onOk={this.handleOkButton}
                    okLabel={modalOkLabel}
                    loading={submitting}
                    noActions={loading || submitting}
                    title={"+ New Claim"}
                    additionalAction={additionalAction}
                    classes={classes}
                >
                    <CreateClaimForm />
                    {error && (
                        <Alert icon={false} severity="error" className={styles.error} onClose={() => setError(null)} style={{ whiteSpace: 'pre-wrap' }}>
                            {error}
                        </Alert>
                    )}
                </ModalDialog>

                {this.state.showCreateClaimSuccessModal && (
                    <Dialog
                        open={this.state.showCreateClaimSuccessModal}
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Successfully created claim, number : {createdClaimNumber}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.closeModal(`CreateClaimSuccess`)} color="primary">
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>

                )}
                {this.state.showCreateClaimQueuedSuccessModal && (
                    <Dialog
                        open={this.state.showCreateClaimQueuedSuccessModal}
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Successfully queued claim submission
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.closeModal(`CreateClaimQueuedSuccess`)} color="primary">
                                OK
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}

                <ClaimDocumentUpload open={this.state.showDocumentUploadModal}
                                     files={files} maxSize={MAX_FILE_SIZE}
                                     onDrop={this.onDrop}
                                     onDropRejected={this.onDropRejected}
                                     onDropAccepted={this.onDropAccepted}
                                     onSubmit={this.handleDocumentUploadSubmit}
                                     onCancel={this.handleDocumentUploadCancel}
                                     onStageFile={this.handleStageFile}
                                     fileErrors={fileErrors}
                                     uploadErrors={uploadErrors}
                                     claim={selectedClaim}
                                     claimUploadDocumentType={selectedClaimUploadDocumentType || ''}
                                     claimDocumentTypeOptions={claimDocumentTypeOptions}
                                     setClaimUploadDocumentType={this.setClaimUploadDocumentType}
                                     uploading={uploading}
                                     handleStageFile={this.handleStageFile}
                                     removeStagedFile={this.removeStagedFile}
                                     stagedFiles={this.state.stagedFiles}

                />
                <UploadedDocuments open={this.state.showUploadedDocumentsModal}
                                   claim={selectedClaim}
                                   onClose={this.handleShowUploadedDocumentsClose}
                                   onDownload={(file)=>this.getUploadedDocument(file,true)}
                                   onView={(file)=>this.getUploadedDocument(file,false)}
                                   fetching={fetching}
                />
                <ClaimDownloadReport
                    open={this.state.showDownloadReportModal}
                    onSubmit={this.handleDownloadReportSubmit}
                    onCancel={() => this.closeModal(`DownloadReport`)}

                />
                <GenerateDialog
                    showDialog = {this.state.showGeneratingReportModal}
                    handleCloseDialog = {()=>this.closeModal(`GeneratingReport`)}
                    classes = { classes }
                    polling = { polling }
                    loading = { loading}
                    existingReports = { existingReports }
                    generateReport = { this.generateReport }
                    reportRequest = { reportRequest }
                    error = { reportError }
                    downloadUrl = { this.downloadUrl}
                    hideDelayMessage = { true }
                />
            </Container>
        );
    }



}

export default withStyles(styles)(withRouter(ClaimsContainer));
